import { compact, flattenDeep } from 'lodash'
import { actionTypes, change, FormAction } from 'redux-form'
import * as Effects from 'redux-saga/effects'
import { put } from 'redux-saga/effects'
import requestCopyReservation from '../../../actions/bookingCalendar/event/copyReservation'
import { createBulkEvents } from '../../../actions/bookingCalendar/event/requestCreateEvent'
import { eventWasUpdated } from '../../../actions/bookingCalendar/event/requestUpdateEvent'
import { callFetch } from '../../../actions/fetch'
import { IFormAction } from '../../../actions/form/createFormActions'
import { requestSynchronization } from '../../../actions/synchronize/synchronize'
import { fireToastError } from '../../../actions/toasts/fireToast'
import fireToastSuccess from '../../../actions/toasts/fireToastSucces'
import { ICopyFormValues } from '../../../containers/BookingCalendar/CopyReservationModal/CopyReservationForm'
import i18n from '../../../i18n'
import { IEvent } from '../../../models/Event'
import requestCreate from '../../../models/Event/createEvent'
import requestUpdate from '../../../models/Event/updateEvent'
import { UpdateLimitType } from '../../../models/Limit'
import fetchActionsName, { ActionNames } from '../../../utils/FetchActionsName'
import {
  LimitResponse,
  LimitType,
  loadLimits,
} from '../../userAccount/loadLimits'
import updateLimits from '../../userAccount/updateLimits'

function* copy(action: IFormAction<ICopyFormValues>) {
  const formData = action.payload

  const response = yield* loadLimits(LimitType.Copy)
  if (response === LimitResponse.Rejected) {
    yield Effects.put(requestCopyReservation.failure())
    return
  }

  const eventsCall = []
  let createdEvents = []
  let updatedEvents = []

  const actionNamesCreate = fetchActionsName(ActionNames.CreateEvent)
  const actionNamesUpdate = fetchActionsName(ActionNames.UpdateEvent)
  const serviceCreate = yield Effects.all([
    Effects.take(actionNamesCreate.output),
    Effects.put(
      callFetch(
        actionNamesCreate.input,
        actionNamesCreate.output,
        requestCreate,
      ),
    ),
  ])
  const serviceUpdate = yield Effects.all([
    Effects.take(actionNamesUpdate.output),
    Effects.put(
      callFetch(
        actionNamesUpdate.input,
        actionNamesUpdate.output,
        requestUpdate,
      ),
    ),
  ])


  if (!formData.eventId) {
    try {
      const created: IEvent[] = yield Effects.call(
        serviceCreate[0].service,
        serviceCreate[0].calendarId,
        formData.eventData,
      )

      createdEvents = createdEvents.concat(created)
    } catch (e) {}
  } else {
    try {
      const updated: IEvent[] = yield Effects.call(
        serviceUpdate[0].service,
        serviceUpdate[0].calendarId,
        formData.eventId,
        formData.eventData,
      )

      updatedEvents = updatedEvents.concat(updated)
    } catch (e) {}
  }

  for (const key in formData.room) {
    if (!formData.room[key]) {
      continue
    }

    eventsCall.push(
      Effects.call(serviceCreate[0].service, serviceCreate[0].calendarId, {
        ...formData.eventData,
        ...{
          dateFrom: formData.dateFrom,
          dateTo: formData.dateTo,
          roomId: key,
        },
      }),
    )
  }

  try {
    const eventsApi = yield Effects.all(eventsCall)
    const events = compact(flattenDeep(eventsApi))

    for (const event in events) {
      createdEvents.push(events[Number(event)])
    }

    for (const event of updatedEvents) {
      yield Effects.put(eventWasUpdated(event))
    }

    yield* updateLimits(UpdateLimitType.Copy)
    yield Effects.put(createBulkEvents(compact(createdEvents)))

    yield Effects.put(
      fireToastSuccess(
        i18n.t('z677_reservation_has_been_copied'),
        5000,
        'Main',
        'ReservationCopiedElegancko',
      ),
    )
    yield Effects.put(requestCopyReservation.success())
  } catch (e) {
    if (e.message === '409') {
      yield Effects.put(requestSynchronization())
      yield Effects.put(
        fireToastError(
          i18n.t('reservation_reserved_date_error'),
          null,
          'Main',
          'CopyCannotCreate',
        ),
      )
    } else if (e.message === 'Period is not free') {
      yield put(
        fireToastError(
          i18n.t('z677_period_is_not_free'),
          undefined,
          undefined,
          'reservation_update_error',
        ),
      )
    } else {
      console.error(e)
      yield Effects.put(fireToastError(i18n.t('error_server_response_2')))
    }
    yield Effects.put(requestCopyReservation.failure())
  }
}

function* clearUnregisteredField(action: FormAction) {
  if (
    action.meta.form === 'copyForm' &&
    action.payload.name.indexOf('room') === 0
  ) {
    yield Effects.put(change('copyForm', action.payload.name, null))
  }
}

export default function* () {
  yield Effects.takeLatest(requestCopyReservation.TRIGGER, copy)
  yield Effects.takeEvery(actionTypes.UNREGISTER_FIELD, clearUnregisteredField)
}
